import React from 'react';
import { useSelector } from 'react-redux';
import { fullstorySelectors } from '@fullstory/redux';
import { UpgradeLink } from '../../components/UpgradeLink';
import { PlanStage, BasePlan } from '@fullstory/proto/fs/services/orgs';

interface UpgradeLinkContainerProps {
  isSettingsPage?: boolean;
}

export const UpgradeLinkContainer: React.FunctionComponent<UpgradeLinkContainerProps> = ({
  isSettingsPage,
}) => {
  const orgStage = useSelector(fullstorySelectors.getOrgStage);
  const trialExpiration = useSelector(fullstorySelectors.getTrialExpiration);
  const basePlan = useSelector(fullstorySelectors.getBasePlan);
  const enterpriseActive =
    basePlan == BasePlan.ENTERPRISE_PLAN && orgStage != PlanStage.TRIAL_STAGE;
  if ((enterpriseActive && !isSettingsPage) || (!enterpriseActive && isSettingsPage)) {
    // We only show for enterprise on settings page.
    return <></>;
  }
  return (
    <UpgradeLink
      stage={orgStage}
      basePlan={basePlan}
      exp={trialExpiration}
      now={new Date().valueOf()}
      showStar={false}
      size={isSettingsPage ? 'medium' : 'x-small'}
    />
  );
};
